import React from "react";
import PropTypes from "prop-types";
import { Typography, Box } from "@mui/material";

const NonEditableField = ({ fieldName, fieldValue, align }) => {
  return (
    <Box display="flex" flexDirection="column" alignItems={align}>
      <Box pb={1}>
        <Typography variant="caption" color="textSecondary">
          {fieldName}
        </Typography>
      </Box>
      <Typography
        variant="subtitle1"
        color="textPrimary"
        data-qa="non-editable-field-value"
      >
        {fieldValue}
      </Typography>
    </Box>
  );
};

export default NonEditableField;

NonEditableField.propTypes = {
  fieldName: PropTypes.string,
  fieldValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

NonEditableField.defaultProps = {
  align: { xs: "center", sm: "flex-start" }
};
